import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { AuditLogAction } from "./types";

export const AuditLogActionOptions = [
  {
    label: i18n.t("addNew"),
    value: AuditLogAction.Create,
  },
  {
    label: i18n.t("update"),
    value: AuditLogAction.Update,
  },
  {
    label: i18n.t("delete"),
    value: AuditLogAction.Delete,
  },
  {
    label: i18n.t("import"),
    value: AuditLogAction.Import,
  },
  {
    label: i18n.t("export"),
    value: AuditLogAction.Export,
  },
  {
    label: i18n.t("sendMail"),
    value: AuditLogAction.SendMail,
  },
  {
    label: i18n.t("lockDataBtn"),
    value: AuditLogAction.Lock,
  },
  {
    label: i18n.t("unlockData"),
    value: AuditLogAction.Unlock,
  },
  {
    label: i18n.t("runPayroll"),
    value: AuditLogAction.Run,
  },
  {
    label: i18n.t("approve"),
    value: AuditLogAction.Approve,
  },
  {
    label: i18n.t("reject"),
    value: AuditLogAction.Reject,
  },
  {
    label: i18n.t("sync"),
    value: AuditLogAction.Sync,
  },
  {
    label: i18n.t("assign"),
    value: AuditLogAction.Assign,
  },
  {
    label: i18n.t("sendToApprove"),
    value: AuditLogAction.SendToApprove,
  },
  {
    label: i18n.t("runPayroll"),
    value: AuditLogAction.RunPayroll,
  },
  {
    label: i18n.t("createBulk"),
    value: AuditLogAction.CreateBulk,
  },
];

export const AuditLogActionMap = getMapObjectFromArray(AuditLogActionOptions);
